<template>
  <el-dialog
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    append-to-body
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="130px"
      v-loading="formLoading"
    >
      <el-form-item label="国家" prop="customerCountry">
        <el-select
          filterable
          clearable
          v-model="form.customerCountry"
          placeholder="请选择国家"
          @change="changeCountry"
        >
          <el-option
            v-for="item in nationList.slice(1)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="公司" prop="customerCompanyName">
        <el-select
          :disabled="form.customerCountry ? false : true"
          filterable
          clearable
          v-model="form.customerCompanyName"
          placeholder="请选择公司"
          @change="changeCompany"
        >
          <el-option
            v-for="item in companyList"
            :key="item.customerCompanyName"
            :label="item.customerCompanyName"
            :value="item.customerCompanyName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户账号" prop="customerAccountNum">
        <el-select
          :disabled="form.customerCompanyName ? false : true"
          filterable
          clearable
          multiple
          v-model="form.customerAccountNum"
          placeholder="请选择客户账号"
        >
          <el-option
            v-for="item in customerList"
            :key="item.customerAccountNum"
            :label="item.customerAccountNum"
            :value="item.customerAccountNum"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结算币种" prop="currency">
        <el-select v-model="form.currency" placeholder="请选择结算币种" filterable clearable>
          <el-option label="CNY" :value="0"> </el-option>
          <el-option label="USD" :value="1"> </el-option>
          <el-option label="RUB" :value="2"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="索赔时工时单价" prop="claimUnitPrice">
        <!-- <el-input
          v-model="form.claimUnitPrice"
          type="number"
          placeholder="请输入"
        /> -->
        <el-input-number
          v-model="form.claimUnitPrice"
          :controls="false"
          :precision="2"
          placeholder="请输入索赔时工时单价"
          class="number-input"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="索赔管理费费率" prop="claimManagementRate">
        <!-- <el-input
          v-model="form.claimManagementRate"
          type="number"
          placeholder="请输入"
        /> -->
        <el-input-number
          v-model="form.claimManagementRate"
          :controls="false"
          :max="1"
          :precision="3"
          placeholder="请输入索赔管理费费率"
          class="number-input"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="有效期" prop="dateRange">
        <el-date-picker
          v-model="form.dateRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleDateChange"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-button">
      <el-button type="primary" :loading="saveLoading" @click="handleSave">
        确定
      </el-button>
      <el-button type="primary" plain @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getSession } from "@/util/localStor";
import { presetAdd, presetEdit } from "@/api/seek";
import { getCompanyList, getCustomer } from "@/api/api";

export default {
  components: {},
  dicts: [],
  data() {
    return {
      title: "",
      dialogVisible: false,
      formLoading: false,
      saveLoading: false,
      form: this.getForm(),
      rules: {
        customerCountry: [{ required: true, message: "请选择国家" }],
        customerCompanyName: [{ required: true, message: "请选择公司" }],
        customerAccountNum: [{ required: true, message: "请选择客户" }],
        currency: [{ required: true, message: "请选择币种" }],
        claimUnitPrice: [{ required: true, message: "请输入索赔时工时单价" }],
        claimManagementRate: [
          { required: true, message: "请输入索赔管理费费率" }
        ],
        dateRange: [{ required: true, message: "请选择有效期" }]
      },
      nationList: [],
      companyList: [],
      customerList: []
    };
  },
  mounted() {
    this.nationList = Object.values(getSession("nationList"));
  },
  methods: {
    handleDateChange() {
      if (this.form.dateRange && this.form.dateRange.length === 2) {
        const endDate = this.form.dateRange[1] + " 23:59:59";
        if (new Date(endDate) < new Date()) {
          this.$DonMessage.warning("结束日期不能小于今天");
          this.form.dateRange = []; // 重置结束日期
        }
      }
    },
    // 修改国家
    changeCountry() {
      this.form.customerCompanyName = "";
      this.companyList = [];
      this.form.customerAccountNum = [];
      this.customerList = [];
      this.getCompanyList();
    },
    // 根据国家获取公司列表
    async getCompanyList() {
      const res = await getCompanyList({
        customerCountry: this.form.customerCountry
      });
      this.companyList = res.data;
    },
    // 修改公司
    changeCompany() {
      this.form.customerAccountNum = [];
      this.customerList = [];
      this.getCustomerList();
    },
    // 根据公司获取客户账号列表
    async getCustomerList() {
      const res = await getCustomer({
        customerCompanyName: this.form.customerCompanyName
      });
      this.customerList = res.data;
    },
    // 初始化
    async init(title, data = {}) {
      this.title = title;
      this.dialogVisible = true;
      this.formLoading = true;
      this.form = this.getForm(data);
      if (data.customerCountry) {
        await this.getCompanyList();
      }
      if (data.customerCompanyName) {
        await this.getCustomerList();
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.formLoading = false;
    },
    // 获取表单对象
    getForm(data = {}) {
      return {
        presetDataId: data.presetDataId || "",
        customerCountry: data.customerCountry || "",
        customerCompanyName: data.customerCompanyName || "",
        customerAccountNum: data.customerAccountNum
          ? data.customerAccountNum.split(",")
          : [],
        currency: data.currency,
        claimUnitPrice: data.claimUnitPrice || undefined,
        claimManagementRate: data.claimManagementRate || undefined,
        dateRange:
          data.startTime && data.endTime ? [data.startTime, data.endTime] : []
      };
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        this.saveLoading = true;
        try {
          const submitData = JSON.parse(JSON.stringify(this.form));
          submitData.startTime = submitData.dateRange[0];
          submitData.endTime = submitData.dateRange[1];
          delete submitData.dateRange;
          submitData.customerAccountNum = submitData.customerAccountNum.join(
            ","
          );
          let res = {};
          if (submitData.presetDataId) {
            res = await presetEdit({ data: submitData });
          } else {
            res = await presetAdd({ data: submitData });
          }
          if (res.status == 0) {
            this.dialogVisible = false;
            this.$DonMessage.success("操作成功！");
            this.$emit("success");
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
        this.saveLoading = false;
      });
    }
  }
};
</script>

<!-- <style lang="scss" scoped>
.dialog-container {
  ::v-deep .el-dialog {
    border-radius: 5px;

    .el-dialog__header {
      height: 47px;
      padding: 0 12px 0 28px;
      border-bottom: 1px solid #efefef;
      border-radius: 5px 5px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .el-dialog__title {
        color: #333333;
        font-size: 18px;
      }

      .el-dialog__headerbtn {
        position: unset;
        font-size: 22px;
      }
    }

    .el-dialog__footer {
      text-align: center;
      border-top: 1px solid #efefef;
      padding: 20px 20px 26px 20px;
    }

    .el-form--inline {
      .el-form-item__content {
        > div {
          width: 200px;
        }
      }
    }
    .number-input {
      .el-input__inner {
        text-align: left;
      }
    }
  }
}
</style> -->
